import * as React from 'react';
import { PageContent } from '@core/ui';
import { TableProvider } from '@core/table';

import { BoxTransfersTableContext } from '../context';
import { useBoxTransfersTableContext } from '../hooks';
import { BoxTransfersActionBar, BoxTransfersTable } from '../containers';
import { BoxTransfersPropsType } from '../interfaces';

export const BoxTransfersPage: React.FC<BoxTransfersPropsType> = ({ requestId, requestType }) => {
  const { handleFetch, defaultState } = useBoxTransfersTableContext(requestId, requestType);

  return (
    <TableProvider name='box-transfers' useCache={false} defaultState={defaultState} context={BoxTransfersTableContext} onFetch={handleFetch}>
      <PageContent $contain={true}>
        <BoxTransfersActionBar />
        <BoxTransfersTable />
      </PageContent>
    </TableProvider>
  );
};
